/**
 * Lo que muestra una categoria o una linea sin nada publicado todavia. Con el
 * catalogo en carga esto pasa, y la salida es la de siempre: WhatsApp.
 */
import { Icono } from '../comunes/Icono';

export function SinProductosPublicados() {
  return (
    <div className="vacio">
      <span className="vacio-icono">
        <Icono nombre="caja" />
      </span>
      <h2>Todavía no hay productos publicados acá</h2>
      <p>Estamos cargando el catálogo. Escríbenos por WhatsApp y te confirmamos al tiro.</p>
    </div>
  );
}
